import React from 'react'
import axios from 'axios'
import _ from 'lodash'

import { mediaApiPrefix } from '../../constants'
import { toast } from 'react-toastify'
import { CopyText } from '../../components'

const fileLimit = 6*(1e+7) //60MB

export const uploadFile = file => new Promise((resolve, reject) => {
  if (file.size > fileLimit) {
    toast.warn('File is too big. Maximum 60 MB is allowed', {
      position: toast.POSITION.TOP_RIGHT,
    })
    return reject()
  }
  const formData = new FormData()
  formData.append('newMedia', file)
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  axios
    .post(`${mediaApiPrefix}new`, formData, {
      cancelToken: source.token,
      headers: {
        'content-type': 'multipart/form-data',
        'File-Size': file.size,
        'File-Name': encodeURIComponent(file.name),
        'File-Type': file.type,
      },
      withCredentials: true,
    })
    .then(result => {
      resolve({ url: result.data.mediaURL })
    })
    .catch(err => {
      reject(err)
      const message = _.get(err, 'response.data.error.value') ||
      _.get(err, 'response.data') ||
       'Oops, Something went wrong!'

      toast.error(<CopyText message={message}/>, {
        position: toast.POSITION.TOP_RIGHT,
      })
    })
})
